// utils/queryOptions.js
export const activityLogQueryOptions = {
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    // ...other shared options
};

export const getActivityLogQueryOptions = (objectType, objectId) => ({
    queryKey: objectId ? ['activity-logs', objectType, objectId] : ['activity-logs', objectType],
    enabled: !!objectType,
    ...activityLogQueryOptions,
});

export const getStoreLocationsQueryOptions = () => ({
    queryKey: ['store-locations'],
    staleTime: 10 * 60 * 1000, // 10 minutes
});

export const getStoreLocationQueryOptions = (locationId) => ({
    queryKey: ['store-location', locationId],
    enabled: !!locationId,
    ...activityLogQueryOptions,
});

export const getPurchaseOrderDetailQueryOptions = (poId) => ({
    queryKey: ['PurchaseOrderDetail', poId],
    enabled: !!poId,
    ...activityLogQueryOptions,
});

export const programQueryOptions = {
    staleTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: true,
};

export const getProgramQueryOptions = (programId) => ({
    queryKey: ['programs', `program-${programId}`],
    ...programQueryOptions,
});

// Customer Program Admin Query Options
export const customerProgramAdminQueryOptions = {
    staleTime: 0, // always fresh
    refetchOnWindowFocus: true,
};

export const getCustomerProgramAdminQueryOptions = (customerId, programId) => ({
    queryKey: ['customer-program-admin', customerId, programId],
    enabled: !!customerId && !!programId,
    ...customerProgramAdminQueryOptions,
});
